import React, { useEffect, useReducer, useState } from 'react';
import { Button } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import RedoIcon from '@mui/icons-material/Redo';
import UndoIcon from '@mui/icons-material/Undo';
import './GuestView.scss';
import GuestLayout from './GuestLayout';
import {
  EMAIL_BODY,
  EMAIL_BUTTON_COMPONENT,
  EMAIL_DIVIDER_COMPONENT,
  EMAIL_HEADER,
  EMAIL_IMAGE_COMPONENT,
  EMAIL_TEXT_COMPONENT,
} from '../../../../../constants/EmailServicesConst';
import GuestRightPanel from './GuestRightPanel';
import LayoutPreview from './LayoutPreview';
import { updateEmailServiceTemplates } from '../../../../../utils/cmsUtils';
import { useDispatch } from 'react-redux';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { fetchAllEmailServices } from '../../../../services/servicesSlice';
import { decryptLocalStorage } from '../../../../../utils/authUtils';

const GuestView = (props) => {
  const { onViewToggle, guest, hotelId, groupId } = props;
  const dispatch = useDispatch();
  const [activeSection, setActiveSection] = useState(null);
  const [activeNdx, setActiveNdx] = useState(-1);
  const [isPreview, setIsPreview] = useState(false);
  const [isDragged, setIsDragged] = useState(false);
  const [componentsList, setComponentsList] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { header: {}, body: [], footer: { image: {}, text: {}, social: {} } },
  );

  const setDefaultValue = (dataSet, type) => {
    const defaultValue = {
      left: dataSet.left || 10,
      right: dataSet.right || 10,
      top: dataSet.top || 10,
      bottom: dataSet.bottom || 10,
      width: dataSet.width || 200,
      height: dataSet.height || 200,
      alignment: dataSet.alignment || 'center',
    };
    if (type !== 'image') {
      delete defaultValue.width;
      delete defaultValue.height;
      defaultValue.fontSize = dataSet.fontSize || 14;
    }
    return defaultValue;
  };

  useEffect(() => {
     if (!guest) return;
   const emailTemplate = guest.emailTemplate || {};
    const header = emailTemplate.header || {};
    const footer = emailTemplate.footer || { image: {}, text: {}, social: {} };

    let sortBody = [];
    if (Array.isArray(emailTemplate.body) && emailTemplate.body.length > 0) {
      const first = emailTemplate.body[0] || {};
      const newBody = []
        .concat(first.text || [], first.image || [], first.button || [], first.divider || []);
      if (newBody.length > 0) {
        sortBody = newBody.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
      }
    }

    const currComponentsList = { ...componentsList };
    const defaultHeaderValue = setDefaultValue(header, 'image');
    const defaultFooterImage = setDefaultValue(footer.image || {}, 'image');
    const defaultFooterText = setDefaultValue(footer.text || {}, 'text');
    const defaultFooterSocial = setDefaultValue(footer.social || {}, 'social');
    currComponentsList.header = { ...header, ...defaultHeaderValue };
    currComponentsList.body = sortBody;
    currComponentsList.footer = {
      ...footer,
      image: { ...(footer.image || {}), ...defaultFooterImage },
      text: { ...(footer.text || {}), ...defaultFooterText },
      social: { ...(footer.social || {}), ...defaultFooterSocial },
    };
    setComponentsList(currComponentsList);
    
  }, [guest]);

  const onItemChange = async (currentObj) => {
    const currSelection =
      activeSection === EMAIL_HEADER ? 'header' : activeSection === EMAIL_BODY ? 'body' : 'footer';
    if (currSelection === 'header') return setComponentsList({ [currSelection]: currentObj });
    if (currSelection === 'footer') {
      const componentType =
        currentObj.id === EMAIL_IMAGE_COMPONENT
          ? 'image'
          : currentObj.id === EMAIL_TEXT_COMPONENT
          ? 'text'
          : 'social';
      return await setComponentsList({
        [currSelection]: {
          image: { ...componentsList.footer.image },
          text: { ...componentsList.footer.text },
          social: { ...componentsList.footer.social },
          [componentType]: currentObj,
        },
      });
    }
    const currCompList = [...componentsList.body];
    currCompList[currentObj.index] = {
      ...currentObj,
      selected: currCompList[currentObj.index].selected,
      title: currCompList[currentObj.index].title,
    };
    setComponentsList({ body: currCompList });
  };

  const onClickComponent = (e, index) => {
    setActiveNdx(index);
    const currComponentsList = componentsList.body.map((item, i) => {
      if (index === i) {
        return { ...item, index };
      } else {
        return { ...item, selected: false };
      }
    });
    setComponentsList({ body: currComponentsList });
  };

  const onClickBack = (e) => {
    e.preventDefault();
    if (componentsList.body.lenght === 0 || activeNdx === -1) return false;
    const currComponentsList = [...componentsList.body];
    currComponentsList[activeNdx].selected = false;
    setComponentsList({ body: currComponentsList });
    setActiveNdx(-1);
  };

  const getImageAligin = (alignment) => {
    if (!alignment) return 'center';
    if (alignment === 'left') return 'start';
    if (alignment === 'center') return alignment;
    if (alignment === 'right') return 'end';
  };

  const onRemoveComponent = () => {
    const currBodyComponent = [...componentsList.body];
    currBodyComponent.splice(activeNdx, 1);
    setComponentsList({ body: currBodyComponent });
    setActiveNdx(-1);
  };

  const deleteSetValues = (dataSet, id) => {
    if (id) {
      const currData = componentsList.body.filter((currBody) => currBody.id === id);
      if (currData.length > 0)
        return currData.map((val) => {
          delete val.isValid;
          delete val.selected;
          delete val.title;
          return { ...val };
        });
      return [];
    }
    delete dataSet.index;
    delete dataSet.isValid;
    delete dataSet.selected;
    delete dataSet.hyperLink;
    return dataSet;
  };

  const onSaveTemplate = async () => {
    try {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const currBodyText = deleteSetValues(null, EMAIL_TEXT_COMPONENT);
      const currBodyImage = deleteSetValues(null, EMAIL_IMAGE_COMPONENT);
      const currBodyButton = deleteSetValues(null, EMAIL_BUTTON_COMPONENT);
      const currBodyDivider = deleteSetValues(null, EMAIL_DIVIDER_COMPONENT);
      const currheader = deleteSetValues(componentsList.header, null);
      const currFooterImage = deleteSetValues(componentsList.footer.image, null);
      const currFooterText = deleteSetValues(componentsList.footer.text, null);
      const currFooterSocial = deleteSetValues(componentsList.footer.social, null);
      const payload = {
        bcc: guest.bcc,
        cc: guest.cc,
        fromAddess: guest.fromAddess,
        fromName: guest.fromName,
        hotelId: guest.hotelId,
        id: guest.id,
        name: guest.name,
        subject: guest.subject,
        emailTemplate: {
          header: { ...currheader },
          body: [
            {
              text: [...currBodyText],
              image: [...currBodyImage],
              button: [...currBodyButton],
              divider: [...currBodyDivider],
            },
          ],
          footer: {
            image: { ...currFooterImage },
            text: { ...currFooterText },
            social: { ...currFooterSocial },
          },
        },
      };
      await updateEmailServiceTemplates(payload, language);
      dispatch(fetchAllEmailServices(hotelId));
      notificationManager('success', 'Email template updated successfully');
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors
          ? e.graphQLErrors[0].message
          : 'Error occurred while updating email template',
      );
    }
  };

  const disableSave = () => {
    if (
      componentsList.header.isValid === false ||
      componentsList.footer.image.isValid === false ||
      componentsList.footer.text.isValid === false ||
      componentsList.footer.social.isValid === false
    )
      return true;
    const isValidBody = componentsList.body.some((currBody) => currBody.isValid === false);
    if (isValidBody) return true;
    return false;
  };

  return (
    <div className='container mt-5 pt-4 guest-view'>
      <div className='row'>
        <div className='col-md-8'>
          <div className='row'>
            <div className='align-self-center col-md-1 d-flex'>
              <Button
                variant='text'
                color='secondary'
                size='small'
                startIcon={<ArrowBack />}
                onClick={(e) => onViewToggle(null, false, null)}
                className='me-2'
              >
                Back
              </Button>
            </div>
            <div className='col-md-9'>
              <div className='title-wrapper'>
                <p className='title-name'>{guest.name}</p>
                <p className='title-icon'>
                  <MoreHorizIcon />
                </p>
              </div>
            </div>
            <div className='align-self-center col-md-1 d-flex'>
              <Button
                variant='contained'
                color='primary'
                size='small'
                onClick={() => setIsPreview(true)}
                className='me-2 btn-preview'
              >
                Preview
              </Button>
            </div>
            <div className='align-self-center col-md-1 d-flex'>
              <Button
                variant='contained'
                color='primary'
                size='small'
                onClick={(e) => onSaveTemplate()}
                className='me-2 btn-save'
                disabled={disableSave()}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
        <div className='col-md-4'>
          <div className='d-flex justify-content-end'>
            <div className='arrow-icon'>
              <UndoIcon />
            </div>
            <div className='arrow-icon'>
              <RedoIcon />
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-8'>
          <div className='card shadow mt-4 mb-4 pb-5'>
            <GuestLayout
              activeSection={activeSection}
              setActiveSection={setActiveSection}
              componentsList={componentsList}
              setComponentsList={setComponentsList}
              onClickComponent={onClickComponent}
              onClickBack={onClickBack}
              getImageAligin={getImageAligin}
              setIsDragged={setIsDragged}
              isDragged={isDragged}
            />
          </div>
        </div>
        {activeSection && (
          <div className='col-md-4 mt-4 px-0'>
            <GuestRightPanel
              activeSection={activeSection}
              onItemChange={onItemChange}
              componentsList={componentsList}
              activeNdx={activeNdx}
              onClickBack={onClickBack}
              setIsDragged={setIsDragged}
              setActiveSection={setActiveSection}
              onRemoveComponent={onRemoveComponent}
              groupId={groupId}
            />
          </div>
        )}
      </div>
      {isPreview && (
        <LayoutPreview
          isPreview={isPreview}
          setIsPreview={setIsPreview}
          componentsList={componentsList}
          getImageAligin={getImageAligin}
          guest={guest}
        />
      )}
    </div>
  );
};

export default GuestView;
